import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { ChannelRepository } from "app/js/src/domain/channel-repository";
import { LiveFeedRepository } from "app/js/src/domain/live-feed-repository";
import {
  RecordingSource,
  RecordingSourceType,
} from "app/js/src/domain/recording-source";
import { v4 as uuid } from "uuid";
import { Socket } from "app/js/src/infrastructure/socket.service";
import { RecordingService } from "app/js/src/services/recording/recording.service";
import { Subscription } from "rxjs";
import { UI } from "app/js/src/services/ui.service";
import { WebRTCPreview } from "app/js/src/domain/web-r-t-c-preview";
import { UserService } from "app/js/src/domain/user-service";
import { Router } from "@angular/router";
@Component({
  selector: "evrideo-recording-assets-manager",
  templateUrl: "./recording-assets-manager.component.html",
  styleUrls: ["./recording-assets-manager.component.scss"],
})
export class RecordingAssetsManagerComponent implements OnInit, OnDestroy {
  channelsSources: Array<RecordingSource> = [];
  feedsSources: Array<RecordingSource> = [];
  searchTerm = "";
  //recordingJobsChanged: Subscription;
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private channelRepository: ChannelRepository,
    private liveFeedRepository: LiveFeedRepository,
    private socketService: Socket,
    private ui: UI,
    private userService: UserService,
    private recordingService: RecordingService,
  ) {}

  ngOnInit() {
    this.channelRepository.getTenantChannels().then((channels) => {
      for (const channel of channels) {
        if (channel.isActive) {
          this.channelsSources.push(
            new RecordingSource(
              uuid(),
              channel.name,
              RecordingSourceType.Channel,
              null,
              channel.uid,
              false,
              channel.placeholderImage || "",
            ),
          );
        }
      }
      this.changeDetectorRef.markForCheck();
      /*this.recordingJobsChanged = this
        .recordingService
        .getRecordingJobCacheUpdateObserver()
        .subscribe(this.checkIfRecordingSourceIsRecording.bind(this));*/
    });
    this.liveFeedRepository.getLiveFeeds().then((feeds) => {
      for (const feed of feeds) {
        this.feedsSources.push(
          new RecordingSource(
            uuid(),
            feed.name,
            RecordingSourceType.LiveFeed,
            null,
            feed.id,
            false,
            feed.thumbnail,
          ),
        );
      }
      this.changeDetectorRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    /*if (this.recordingJobsChanged) {
      this.recordingJobsChanged.unsubscribe();
    }*/
  }

  /*checkIfRecordingSourceIsRecording() {
    this.channelsSources.forEach(channel => {
      this.recordingService.isRecordingSourceRecording(channel.referenceId)
        .then(result => channel.recording = result);
    });
    this.feedsSources.forEach(feed => {
      this.recordingService.isRecordingSourceRecording(feed.referenceId)
        .then(result => feed.recording = result);
    });
  }*/

  onCreateRecordingJobFromManagerRequest(event: {
    type: RecordingSourceType;
    id: string;
  }): void {
    switch (event.type) {
      case RecordingSourceType.Channel:
        const channelSource = this.channelsSources.find(
          (x) => x.referenceId === event.id,
        );
        if (channelSource) {
          this.checkIfSourceIsRecordingAndConfirm(channelSource);
          channelSource.recording = true;
        }
        break;
      case RecordingSourceType.LiveFeed:
        const feedSource = this.feedsSources.find(
          (x) => x.referenceId === event.id,
        );
        if (feedSource) {
          this.checkIfSourceIsRecordingAndConfirm(feedSource);
          feedSource.recording = true;
        }
        break;
    }
  }
  checkIfSourceIsRecordingAndConfirm(source: RecordingSource): void {
    this.recordingService
      .isRecordingSourceRecording(source.referenceId)
      .then((result) => {
        if (result) {
          this.ui.notify(this.ui.EVENTS.ShowConfirm, {
            title: `Start recording`,
            message: `Are you sure that you want to start a new recording?<br>There is already a recording for ${source.name}`,
            buttons: [
              {
                title: "Yes, start recording!",
                callback: () => {
                  this.createRecordingJobFromSource(source);
                },
              },
              {
                title: "No",
                callback: () => {},
              },
            ],
          });
        } else {
          this.createRecordingJobFromSource(source);
        }
      });
  }
  createRecordingJobFromSource(source: RecordingSource): void {
    this.recordingService.createNewRecordingJobForSource(source);
  }
  onCreatePreviewRequest(event: {
    type: RecordingSourceType;
    id: string;
  }): void {
    switch (event.type) {
      case RecordingSourceType.Channel:
        this.channelRepository.getTenantChannels().then((channels) => {
          const channel = channels.find((x) => x.uid === event.id);
          this.socketService
            .createChannelWebRTCPreview(channel)
            .then((preview: WebRTCPreview) => {
              const data = {
                availabilityZoneUrls: preview.availabilityZoneUrls,
                clientId: preview.clientId,
                brodcasterId: preview.brodcasterId,
                tcpOnlyWebRTC: preview.tcpOnlyWebRTC,
                name: channel.name,
              };
              this.openStreamPreviewWindow(data);
            });
        });
        break;
      case RecordingSourceType.LiveFeed:
        this.socketService
          .createLiveFeedPreview(event.id)
          .then((liveFeedPreview: any) => {
            const firstAvailabilityZone = Object.keys(
              liveFeedPreview.availabilityZoneUrls,
            )[0];
            const liveFeed = this.feedsSources.find(
              (x) => x.referenceId === event.id,
            );
            const data = {
              streamId: liveFeedPreview.id,
              availabilityZoneUrls: [
                liveFeedPreview.availabilityZoneUrls[firstAvailabilityZone].url,
              ],
              name: `${liveFeed.name || ""} live feed`,
              clientId: liveFeedPreview.clientId,
              brodcasterId: liveFeedPreview.brodcasterId,
              isMuted: true,
            };
            this.openStreamPreviewWindow(data);
          });
        break;
    }
  }

  onNavigateToSchdulerFromManagerRequest(uid: string) {
    this.channelRepository.getTenantChannels().then((channels) => {
      const channel = channels.find((x) => x.uid === uid);
      if (channel) {
        this.userService.setCurrentChannel(channel);
        this.router.navigate(["/scheduler/calendar"], {
          queryParamsHandling: "preserve",
        });
      }
    });
  }

  openStreamPreviewWindow(data: any): void {
    const id = uuid();
    localStorage.setItem(`stream_data_${id}`, JSON.stringify(data));
    window.open(
      `/html/preview.html?id=${id}`,
      `window_${data.name}`,
      "width=407,height=300,toolbar=no, menubar=no, resizable=yes",
    );
  }
}
